import React from 'react';
import { OperationType } from 'screens/Applications&WorkOrders/RouteAdmin';
import ContentSection from '../ContentSection';
import { Locale, en } from '../../locales';

interface NotesProps {
  notes?: string;
  operationType: OperationType;
  locale: Locale;
  headerContinuedText: string;
}

const Notes: React.FC<NotesProps> = ({
  notes,
  operationType = OperationType.APPLICATION,
  locale = en,
  headerContinuedText
}) => {
  const isWorkOrder = operationType === OperationType.WORK_ORDER;

  if (!notes?.length && !isWorkOrder) {
    return null;
  }

  return (
    <ContentSection
      headerText={locale.notes.title}
      content={notes}
      continuedText={locale.notes.continued}
      headerContinuedText={headerContinuedText}
      hasInputRows={isWorkOrder}
    />
  );
};

export default Notes;
